"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAccruedLiabilitiesParams = void 0;
const formula_engine_1 = require("@finley-technologies/formula-engine");
const utils_1 = require("./utils");
const createAccruedLiabilitiesParams = ({ dataAccessor, }) => {
    const { parameterConfig, variables } = dataAccessor;
    const { startDateFormula, endDateFormula, requiresLatestStatementForPeriod, } = parameterConfig;
    try {
        const { startDate, endDate, } = formula_engine_1.commonFormulas.evaluateStartAndEndDateFormulas({
            startFormula: startDateFormula.params.formula,
            endFormula: endDateFormula.params.formula,
            variables,
        });
        return {
            isValid: true,
            params: {
                startDate,
                endDate,
                requiresLatestStatementForPeriod: Boolean(requiresLatestStatementForPeriod),
            },
        };
    }
    catch (err) {
        return {
            isValid: false,
            errors: (0, utils_1.handleParamsError)(err, {
                prefix: '"createAccruedLiabilitiesParams" Error',
            }),
        };
    }
};
exports.createAccruedLiabilitiesParams = createAccruedLiabilitiesParams;
//# sourceMappingURL=accruedLiabilitiesParams.js.map